import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getAllConditionListAction } from 'src/modules/SuperAdmin/store/actions/condition.action';
import { SuperAdminModal } from '../../../baseComponents';
import * as Yup from 'yup';
import {
  addFormsConditions,
  getAllFormsAction,
} from 'src/modules/SuperAdmin/store/actions/formconditions.action';

const AddNewFormConditions = ({
  isOpen,
  setIsOpen,
  filterSetSelectedOrganizationUUID,
  selectedOrganizationUUID,
  selectedOrganizationName,
}) => {
  const initialValues = {
    condition_id: '',
    form_id: '',
  };
  const { getAllConditionsList } = useSelector(
    (state) => state?.conditionState
  );
  const { forms } = useSelector((state) => state?.formConditionsState);

  const [conditionOptions, setConditionOptions] = useState([]);
  const [formOptions, setFormsOptions] = useState([]);
  const [selectedCondition, setSelectedCondition] = useState(null);

  useEffect(() => {
    if (getAllConditionsList && Array.isArray(getAllConditionsList)) {
      let conditionsArr = [];
      getAllConditionsList.forEach((key) => {
        conditionsArr.push({
          value: key?.condition_id,
          label: key?.condition_name,
        });
      });
      setConditionOptions(conditionsArr);
    }
  }, [getAllConditionsList]);

  useEffect(() => {
    if (forms && Array.isArray(forms)) {
      let formsArr = [];
      forms.forEach((key) => {
        formsArr.push({
          value: key?.form_id,
          label: key?.form_name,
        });
      });
      setFormsOptions(formsArr);
    }
  }, [forms]);

  const validationSchemaField = Yup.object().shape({
    condition_id: Yup.string().required(' '),
    form_id: Yup.string().required(' '),
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllConditionListAction());
  }, [dispatch]);

  const sections = [
    {
      heading: 'Add form condition',
      fields: [],
    },
    {
      className: '',
      fields: [
        {
          name: 'condition_id',
          type: 'select',
          title: 'Condition name',
          placeholder: 'Select condition',
          options: conditionOptions,
          disabled: selectedOrganizationUUID ? false : true,
          onChange: (setFieldValue, e) => {
            setFieldValue('condition_id', e);
            setSelectedCondition(e);
            dispatch(getAllFormsAction(selectedOrganizationUUID, e, null));
          },
        },
      ],
    },
    {
      className: '',
      fields: [
        {
          name: 'form_id',
          type: 'select',
          title: 'Form type',
          placeholder: 'Select form type',
          options: formOptions,
          disabled:
            selectedOrganizationUUID && selectedCondition ? false : true,
          onChange: (setFieldValue, e) => {
            setFieldValue('form_id', e);
          },
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      initialValues={initialValues}
      validationSchema={validationSchemaField}
      className={'form-condition-modal'}
      closable={false}
      submitButtonText="Submit"
      cancelButtonText="Cancel"
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={(values) => {
        const payload = {
          condition_id: values?.condition_id,
          form_id: values?.form_id,
          org_uuid: selectedOrganizationUUID,
        };
        //Filter here refers to what is selected in the home page
        dispatch(
          addFormsConditions(
            payload,
            setIsOpen,
            filterSetSelectedOrganizationUUID,
            selectedOrganizationName
          )
        );
      }}
    />
  );
};

export default AddNewFormConditions;
